module.exports = __webpack_public_path__ + "img/logo-placeholder-image.7f73256b.png";